import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Carousel } from 'antd'
import Image from 'next/image'
import { Icon } from '@iconify/react'
import Link from 'next/link'
import CopyToClipboard from 'react-copy-to-clipboard'
import { useRouter } from 'next/router'
import { useTranslation } from 'src/utils/i18n'
import { Button, message, Space } from 'antd'
import { messageInfo } from 'src/components/Message'

function One(data) {
  const { t } = useTranslation('commonAndroid')

  const step = [
    {
      title: t('Open a browser (Chrome, Firefox, or any other browser).'),
      img: [
        {
          src: '/images/android/two/1.jpg'
        }
      ]
    },
    {
      title: t('Copy or type the link below into the address bar or scan the QR code to go to the download page.'),
      img: [
        {
          src: '/images/android/two/2.png'
        }
      ]
    },
    {
      title: t(
        "<div style='display: inline-block;'>Check the <p style='font-weight: 600;margin:0 5px;display: inline-block;'> I'm not a robot </p> checkbox, pass the<p style='font-weight: 600;display: inline-block;margin:0 5px;'> captcha,  </p> and click <p style='font-weight: 600;margin:0 5px;display: inline-block;'> Download </p> once it's complete. If you see a warning pop-up, press <p style='font-weight: 600;display: inline-block;'> Download anyway.</p></div>"
      ),
      img: [
        {
          src: '/images/android/two/3.jpg'
        }
      ]
    },
    {
      title: t(
        "<div style='display: inline-block;'>After the download is complete, tap <p style='font-weight: 600;margin-right:5px;display: inline-block;'> Open.</p>If you see a warning pop-up, press <p style='font-weight: 600;display: inline-block;'> Settings</p>, look for your browser, and <p style='font-weight: 600;display: inline-block;'> turn the setting on</p>. Then press <p style='font-weight: 600;display: inline-block;'> Install</p>.</div>"
      ),
      img: [
        {
          src: '/images/android/two/4.png'
        },
        {
          src: '/images/android/two/4.1.png'
        },
        {
          src: '/images/android/two/4.2.png'
        },
        {
          src: '/images/android/two/4.3.png'
        }
      ]
    },
    {
      title: t(
        "<div style='display: inline-block;'>After installing the application, press <p style='font-weight: 600;display: inline-block;'> Open</p>. If you see a security pop-up, hit <p style='font-weight: 600;margin-right:5px;display: inline-block;'> IGNORE</p>.</div>"
      ),
      img: [
        {
          src: '/images/android/two/5.png'
        }
      ]
    }
  ]

  const imgToggle = useRef()

  const [currentSlide, setcurrentSlide] = useState(0)

  const [carousel, setCarousel] = useState(step[0].img)

  const [autoplay, setAutoplay] = useState(true)

  const Handler = index => {
    if (index !== 6) {
      setCarousel(step[index].img)
      setcurrentSlide(index)
      setImg(0)

      imgToggle.current.goTo(0)

      /* imgToggle.current.goTo(index) */
    } else {
      /* imgToggle.current.goTo(0) */
      setCarousel(step[index].img)
      setcurrentSlide(index)
    }
  }

  const { query } = useRouter()

  const [a, setA] = useState(1)

  useEffect(() => {
    const interval = setInterval(() => {
      if (autoplay === true) {
        if (parseInt(currentSlide) === 4) {
          setCarousel(step[0].img)
          setcurrentSlide(0)
          setImg(0)
          imgToggle.current.goTo(0)
        } else {
          setCarousel(step[currentSlide + 1].img)
          setcurrentSlide(currentSlide + 1)
          setImg(0)
          imgToggle.current.goTo(0)
        }
      }
    }, [parseInt(currentSlide) !== 3 ? 4000 : 11000])

    // 清除定时器以避免内存泄漏
    return () => clearInterval(interval)
  }, [currentSlide, carousel, query, a, autoplay])

  const [Img, setImg] = useState(0)

  useEffect(() => {
    let startX

    const handleTouchStart = e => {
      // 记录触摸起始位置
      startX = e.touches[0].clientX
    }

    const handleTouchMove = e => {
      // 计算触摸移动距离
      e.preventDefault()

      const currentX = e.touches[0].clientX
      const deltaX = currentX - startX

      // 根据 deltaX 判断左右滑动
      if (deltaX > 0) {
        if (parseInt(currentSlide) === 0) {
          setCarousel(step[4].img)
          setcurrentSlide(4)
          setImg(0)
        } else {
          setCarousel(step[currentSlide - 1].img)
          setcurrentSlide(currentSlide - 1)
          setImg(0)
          imgToggle.current.goTo(0)
        }
      } else if (deltaX < 0) {
        if (parseInt(currentSlide) === 3) {
          if (parseInt(Img) + 1 === carousel.length) {
            setCarousel(step[currentSlide + 1].img)
            setcurrentSlide(currentSlide + 1)
            setImg(0)
            imgToggle.current.goTo(0)
          }
        } else if (parseInt(currentSlide) === 4) {
          if (parseInt(Img) + 1 === carousel.length) {
            setCarousel(step[0].img)
            setcurrentSlide(0)
            setImg(0)
            imgToggle.current.goTo(0)
          }
        } else {
          setcurrentSlide(currentSlide + 1)
          setCarousel(step[currentSlide + 1].img)
          setImg(0)
          imgToggle.current.goTo(0)
        }
      }
    }

    // 添加事件监听器
    document.addEventListener('touchstart', handleTouchStart)
    document.addEventListener('touchmove', handleTouchMove)

    // 清理工作
    return () => {
      document.removeEventListener('touchstart', handleTouchStart)
      document.removeEventListener('touchmove', handleTouchMove)
    }
  }, [currentSlide, carousel, query, a, Img])

  const [copy, setCopy] = useState(false)

  const [messageApi, contextHolder] = message.useMessage()

  const success = () => {
    messageInfo({
      type: 'success',
      content: 'Copied'
    })
  }

  return (
    <div
      className={`w-[620px] Ssm:w-[100%] overflow-x-hidden overflow-auto h-[100%] mx-auto justify-between setup ${data.fullScreen ? 'grid xs:pb-[0px]' : 'Smd:flex overflow-hidden xs:pb-[70px] h-[99%]'
        }`}
    >
      {contextHolder}
      {data.fullScreen && (
        <Icon
          onClick={() => {
            data.setFullScreen(false)
          }}
          icon='maki:cross'
          className={`absolute top-2 right-3 w-[20px] h-[20px] text-black/30`}
        />
      )}

      <div
        onMouseEnter={() => {
          setAutoplay(false), setA(0)
        }}
        onMouseLeave={() => {
          setAutoplay(true), setA(1)
        }}
        className={`w-full text-black Ssm:w-[100%] mx-auto justify-between setup ${data.fullScreen ? 'grid mx-auto' : ' Smd:flex Dsm:mt-[30px] justify-between'
          }`}
      >
        <div className={`w-[343px] ${data.fullScreen ? 'order-2 w-[80%] mx-auto' : 'Dsm:w-[100%] Ssm:mx-auto'}`}>
          <p
            className={`text-[24px] Dsm:text-[20px] pb-[10px] Dsm:mt-[20px] font-[600] Dsm:text-center  ${data.fullScreen ? 'hidden' : ''
              }`}
          >
            {t('Download Msafely installer on the target phone')}
          </p>
          <div className={`pl-1 ${data.fullScreen ? 'pt-[20px]' : 'Dsm:pt-[5px] Dsm:w-[96%] mx-auto pt-[5px]'}`}>
            {step.map((item, index) => {
              return (
                <div
                  onClick={() => Handler(index)}
                  key={index}
                  className={` text-[14px] cursor-pointer  ${data.fullScreen ? 'mt-[10px]' : ' mt-[7px] Dsm:mt-[10px]'
                    }`}
                >
                  <div className='flex'>
                    <p
                      className={`w-[24px] h-[22px] rounded-full flex items-center justify-center -mt-[1px] ${currentSlide === index && 'bg-[#12D8AB] text-white'
                        }`}
                    >
                      {index + 1}.
                    </p>
                    <div
                      className={`ml-1 w-[100%]  ${data.fullScreen ? 'text-[13px]' : 'text-[13px]'}`}
                      dangerouslySetInnerHTML={{ __html: item.title }}
                    />
                  </div>
                  {index === 1 && (
                    <div className='mt-2 pb-2'>
                      <Image
                        width={100}
                        height={100}
                        src='https://image.msafely.com/20231103/msafely_apk_19dbb61286.png'
                        className={`w-[97px] h-[97px] mx-auto`}
                        alt='code'
                      />

                      <div className='bg-[#F0F3F4] rounded-md p-2 flex items-center w-[200px] justify-between mx-auto mt-2'>
                        <Image
                          width={100}
                          height={100}
                          src='/images/android/browser.svg'
                          className={`w-[16px] h-[16px]`}
                          alt='browser'
                        />
                        <CopyToClipboard text={'https://msafely.net/download'}>
                          <div
                            onClick={() => {
                              setCopy(!copy), success()
                            }}
                            className='flex items-center'
                          >
                            <p className='text-[11px] text-[#676CF6] text-center flex items-center justify-center mr-3'>
                              https://msafely.net/download
                            </p>
                            <Icon
                              icon={copy ? 'healthicons:yes' : 'solar:copy-line-duotone'}
                              className='w-[18px] h-[18px] text-[#676CF6]'
                            />
                          </div>
                        </CopyToClipboard>
                      </div>
                    </div>
                  )}
                </div>
              )
            })}
          </div>
        </div>
        <div
          className={`w-[221px] h-[506px] rounded-[24px] p-[6px] border-[1px] border-[#ACB1BD] relative  ${data.fullScreen ? 'order-1 mx-auto' : 'Ssm:hidden'
            }`}
        >
          <Carousel
            autoplay={autoplay}
            className='flex rounded-[15px] border-[#ACB1BD] overflow-hidden border-[1px] w-[207px] h-[449px]'
            ref={imgToggle}
            cancelable={false}
            afterChange={index => { }}
            beforeChange={(index, index2) => {
              setImg(index2)
            }}
          >
            {carousel.map((item, index) => {
              return (
                <div key={index} className='rounded-[15px]'>
                  <Image
                    alt='img'
                    width={100}
                    height={100}
                    src={item.src}
                    className='mx-auto w-[207px] h-[447px] rounded-[15px]'
                  />
                </div>
              )
            })}
          </Carousel>
          <div className='flex items-center justify-center mt-5'>
            {step.map((item, index) => {
              return (
                <div
                  key={index}
                  onClick={() => {
                    setCarousel(step[index].img), setcurrentSlide(index), setImg(0), imgToggle.current.goTo(0)
                  }}
                  className={`border-[1px] border-[#12D8AB] w-[12px] h-[12px] cursor-pointer rounded-[15px] ${index !== 0 && 'ml-2'
                    } ${currentSlide === index && 'bg-[#12D8AB]'} `}
                ></div>
              )
            })}
          </div>
          <div className='absolute -left-[4px] top-[55px]'>
            <Image src='/images/android/1.svg' className='w-[5px] h-[24px]' width={100} height={100} alt='img' />
            <Image src='/images/android/1.svg' className='w-[5px] h-[24px] mt-4' width={100} height={100} alt='img' />
          </div>
        </div>
      </div>

      <div className={`Smd:hidden ${data.fullScreen && 'hidden'}`} onClick={() => data.setFullScreen(true)}>
        <Image
          src='/images/android/watch.png'
          width={100}
          height={100}
          alt='watch'
          className='mx-auto w-[150px] mt-[20px]'
        />
      </div>
    </div>
  )
}

export default One
